import React from 'react'
import Text from '../../Text'
import { $interactivePrimary, $textPrimary } from '../../../styles/colors/semantics'
import styles from './styles.module.css'

function BlackFridayTag({ show }) {
  return (
    <div
      className={[styles.tag, show ? styles.shown : styles.hidden].join(' ')}
      style={{ background: $interactivePrimary.light, color: $textPrimary.dark }}
    >
      <Text type="heading-8">BLACK FRIDAY</Text>
    </div>
  )
}

export default BlackFridayTag
